module.exports = __webpack_public_path__ + "img/flecha-seguir.d9abf408.svg";